/** Etiqueta de estado corta (organización, suscripción, cliente OAuth, webhook, etc.). */
import type { ReactElement, ReactNode } from "react";

export type BadgeTone = "neutral" | "success" | "warning" | "danger";

export function Badge({ tone = "neutral", children }: { tone?: BadgeTone; children: ReactNode }): ReactElement {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}

const ORG_STATUS_TONE: Record<string, BadgeTone> = {
  active: "success",
  trialing: "success",
  suspended: "warning",
  past_due: "warning",
  cancelled: "danger",
  closed: "danger",
  invited: "neutral",
  removed: "danger",
  revoked: "danger",
  disabled: "neutral",
  pending: "neutral",
  delivered: "success",
  failed: "danger",
  hidden: "neutral",
  retired: "danger",
  legacy: "warning",
  public: "neutral",
  confidential: "neutral",
};

/** Elige un tono razonable a partir de un valor de `status` conocido del núcleo. */
export function toneForStatus(status: string): BadgeTone {
  return ORG_STATUS_TONE[status] ?? "neutral";
}
